import { Component, OnInit, ViewChild } from '@angular/core';
import { ModalComponent } from 'src/app/common/modal/modal.component';

@Component({
  selector: 'app-product-category-modal',
  templateUrl: './product-category-modal.component.html',
  styleUrls: ['./product-category-modal.component.scss']
})
export class ProductCategoryModalComponent implements OnInit {

  @ViewChild('editProductCategoryModalOpen') private editProductCategoryModal: ModalComponent;
  constructor() { }

  ngOnInit(): void {
  }

  saveProductCategoryModal(){
  
    console.log("ssss");
    console.log("ssss");
  }

  closeModal(){
    this.editProductCategoryModal.close();
    return "cancel";
  }

}
